<template>
  <div class="page-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="filter">
            <div class="filter-item">
              <div class="label">奖励类型</div>
              <el-select
                v-model="filter.mode"
                size="small"
                class="select"
                placeholder="请选择"
                @change="changeMode"
              >
                <el-option
                  v-for="item in rewardType"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>

            <div class="filter-item">
              <div class="label">变动类型</div>
              <el-select
                v-model="filter.rebateType"
                size="small"
                class="select"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusType"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>

            <div class="filter-item">
              <div class="label">变动者ID：</div>
              <el-input
                class="input"
                v-model="filter.uid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>

            <div class="filter-item">
              <div class="label">发起者ID：</div>
              <el-input
                class="input"
                v-model="filter.fid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>
            <div class="filter-item">
              <div class="label">关联订单号：</div>
              <el-input
                class="input"
                v-model="filter.oid"
                placeholder="请输入内容"
                size="small"
              ></el-input>
            </div>

            <div class="filter-item">
              <div class="label">创建时间：</div>
              <el-date-picker
                v-model="date"
                type="datetimerange"
                align="right"
                unlink-panels
                class="date-input"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                size="small"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="btn-box">
            <button class="search" @click="search">筛选</button>
            <button class="reset" @click="reset">重置</button>
          </div>
        </div>
        <div class="filter-box">
          <div class="btn-box btn-box2">
            <button
              class="search"
              style="margin-left: 60px"
              @click="order2excel"
            >
              导出
            </button>
          </div>
        </div>
        <el-table
          :data="list"
          class="table no-border-table"
          ref="table"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="created" align="center" label="创建时间">
            <div slot-scope="scope">
              {{ scope.row.created | dateFormat }}
            </div>
          </el-table-column>

          <el-table-column prop="rebate_type" align="center" label="奖励类型">
            <div slot-scope="scope">
              {{ rewardMap[scope.row.mode] }}
            </div>
          </el-table-column>
          <el-table-column prop="describe" align="center" label="变动类型">
            <!-- <div slot-scope="scope">
              {{ statusMap[scope.row.rebateType] }}
            </div> -->
          </el-table-column>
          <el-table-column
            prop="amount"
            align="center"
            label="奖励额度"
          ></el-table-column>
          <el-table-column
            prop="uid"
            align="center"
            label="变动者ID"
          ></el-table-column>
          <el-table-column
            prop="fid"
            align="center"
            label="发起者ID"
          ></el-table-column>
          <el-table-column
            prop="oid"
            align="center"
            label="关联单号"
          ></el-table-column>
          <el-table-column prop="status" align="center" label="状态">
            <div slot-scope="scope">
              {{ scope.row.status === 5 ? "已到账" : "" }}
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      title="生成中..."
      :visible.sync="showProgressDialog"
      width="30%"
      center
    >
      <el-progress
        :percentage="progress"
        :text-inside="true"
        :stroke-width="18"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
import myUtils from '../../components/common/whatever2excel';
import dayjs from 'dayjs';
export default {
  components: {
    Header
  },
  name: 'user-manage',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '资金管理',
        secondTitle: '分润记录'
      },
      filter: {
        uid: null,
        fid: null,
        oid: null,
        rebateType: null,
        mode: null
      },
      rewardType: [
        {
          name: '全部',
          value: null
        },
        {
          name: '积分',
          value: 'integral'
        },
        {
          name: '悦贝',
          value: 'gold'
        },
        {
          name: '余额',
          value: 'balance'
        }
        // {
        //   name: '糖果',
        //   value: 'candy'
        // }
      ],
      rewardMap: {
        integral: '积分',
        gold: '悦贝',
        balance: '余额'
        // candy: '糖果'
      },
      statusType: [],
      statusType1: [],
      statusType2: [],
      statusType3: [],
      statusMap: {},
      list: [], // 用户列表
      date: [],
      showProgressDialog: false,
      progress: 0
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  async mounted() {
    // await this.getType();
    // 获取列表
    this.getFundTypeMap();
    this.getList();
  },
  computed: {},
  methods: {
    // async getType() {
    //   await this.httpGet(this.$root.typeList, {
    //     type: 2
    //   }).then((res) => {
    //     this.statusType = [
    //       {
    //         name: '全部',
    //         id: null
    //       }
    //     ];
    //     for (let key in res.list) {
    //       if (key === '8' || key === '51' || key === '52') {
    //         continue;
    //       }
    //       this.statusType.push({
    //         name: res.list[key],
    //         id: key
    //       });
    //     }
    //     this.statusMap = res.list;
    //   });
    // },
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getList();
    },
    getFundTypeMap() {
      this.loading++;
      this.httpGet(this.$root.getFundTypeMap, {}).then(
        (res) => {
          this.loading--;
          // this.typeMap = res.balanceLog;
          let statusType1 = [];
          for (let key in res.rebateLog.integral) {
            statusType1.push({
              name: res.rebateLog.integral[key],
              value: key
            });
          }
          this.statusType1 = [
            {
              name: '全部',
              value: ''
            },
            ...statusType1
          ];
          let statusType2 = [];
          for (let key in res.rebateLog.gold) {
            statusType2.push({
              name: res.rebateLog.gold[key],
              value: key
            });
          }
          this.statusType2 = [
            {
              name: '全部',
              value: ''
            },
            ...statusType2
          ];
          let statusType3 = [];
          for (let key in res.rebateLog.balance) {
            statusType3.push({
              name: res.rebateLog.balance[key],
              value: key
            });
          }
          this.statusType3 = [
            {
              name: '全部',
              value: ''
            },
            ...statusType3
          ];
          this.statusType = [
            {
              name: '全部',
              value: ''
            },
            ...statusType1,
            ...statusType2,
            ...statusType3
          ];
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    changeMode(val) {
      this.filter.rebateType = null;
      if (val === 'integral') {
        this.statusType = [
          ...this.statusType1
        ];
      } else if (val === 'gold') {
        this.statusType = [
          ...this.statusType2
        ];
      } else if (val === 'balance') {
        this.statusType = [
          ...this.statusType3
        ];
      } else {
        this.statusType = [
          ...this.statusType1,
          ...this.statusType2,
          ...this.statusType3
        ];
      }
    },
    // 获取提现列表
    getList() {
      this.filter.begin = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      this.loading++;
      this.httpGet(this.$root.getRebateList, {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 过滤
    search() {
      this.currentPage = 1;
      this.getList();
    },
    // 重置过滤
    reset() {
      this.filter = {
        uid: null,
        fid: null,
        oid: null,
        rebateType: null,
        mode: ''
      };
      this.date = [];
      this.getList();
    },
    async order2excel() {
      this.loading++;
      let list = [];
      let totalPage = null;
      let data = {
        page: this.currentPage,
        size: this.size,
        ...this.filter
      };
      await this.httpGet(this.$root.getRebateList, data).then(
        (res) => {
          this.loading--;
          totalPage = Math.ceil(parseInt(res.total) / this.size);
        },
        () => {
          this.loading--;
        }
      );
      this.showProgressDialog = true;
      this.progress = 0;
      await this.getAllPages(totalPage, list).then(
        () => {
          this.showProgressDialog = false;
          this.jsonFormatAndToExcel(list);
        },
        (err) => {
          console.error(err);
          this.showProgressDialog = false;
        }
      );
    },
    async getAllPages(totalPage, list) {
      for (let i = 1; i <= totalPage; i++) {
        let data = {
          page: i,
          size: this.size,
          ...this.filter
        };
        await this.httpGet(this.$root.getRebateList, data).then((res) => {
          list.push(...res.list);
          this.progress = Math.floor((i / totalPage) * 100);
          console.log('page' + i, list.length);
        });
        // console.log(5555, list);
      }
    },
    jsonFormatAndToExcel(list) {
      let formatList = [];
      list.forEach((item) => {
        let obj = {
          创建时间: item.created,
          奖励类型: this.rewardMap[item.mode],
          变动类型: item.describe,
          奖励额度: item.amount,
          变动者ID: item.uid,
          发起者ID: item.fid,
          关联单号: item.oid,
          状态: item.status === 5 ? '已到账' : ''
        };
        formatList.push(obj);
      });
      myUtils.json2excel(formatList);
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.page-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 10px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      // 按钮
      .btn {
        width: 100px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin: 16px 0;
      }

      .import {
        flex-x(flex-end);
        margin-top: 16px;

        .import-btn {
          confirm-btn();
          height: 32px;
          padding: 0 15px;
          white-space: nowrap;
        }
      }

      // 表格按钮
      .table-btn {
        // width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
        padding: 0 8px;
      }

      .filter-item {
        margin-right: 12px;
      }

      .select, .input {
        width: 120px;
      }

      .date-input {
        width: 350px;
      }

      .btn-box {
        margin: 0;
      }

      .btn-box2 {
        width: 100%;
        flex-x(flex-end);
        margin-top: 8px;
      }

      .table {
        margin-top: 24px !important;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    flex-x(flex-end);
    background: white;
    word(14px, #999);

    span {
      word(20px, #333);
      font-weight: 600;
      margin-left: 3px;
    }
  }

  .dialog-content {
    flex-y();
  }

  .form {
    width: 100%;
    flex-center();
    margin: 8px 0;
  }
}
</style>
